export default __webpack_public_path__ + "static/bannerImg-7df4e263fc6d7261b0e9ee7de39e54e1.webp";